/**
 * Utility functions for browser detection
 */

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  const vendor = navigator.vendor || '';

  // Chrome detection (excluding Edge which also contains Chrome)
  const isChrome = userAgent.includes('Chrome') && !userAgent.includes('Edg') && vendor.includes('Google');
  
  // Safari detection (excluding Chrome which also contains Safari)
  const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome') && vendor.includes('Apple');
  
  // Firefox detection
  const isFirefox = userAgent.includes('Firefox');
  
  // Edge detection
  const isEdge = userAgent.includes('Edg');
  
  // Mobile Safari (iOS)
  const isMobileSafari = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  
  return {
    isChrome,
    isSafari,
    isFirefox,
    isEdge,
    isMobileSafari,
    browserName: isChrome ? 'chrome' : 
                 isSafari ? 'safari' : 
                 isFirefox ? 'firefox' : 
                 isEdge ? 'edge' : 
                 isMobileSafari ? 'mobile-safari' : 'unknown'
  };
};

export const isChrome = () => getBrowserInfo().isChrome;
export const isSafari = () => getBrowserInfo().isSafari;
export const isFirefox = () => getBrowserInfo().isFirefox;
export const isEdge = () => getBrowserInfo().isEdge;
export const isMobileSafari = () => getBrowserInfo().isMobileSafari;

/**
 * Detect if running inside an in-app browser (Facebook, Instagram, LinkedIn, etc.)
 * where custom URL schemes (e.g. iyuga://) are often blocked.
 */
export const isInAppBrowser = () => {
  if (typeof navigator === "undefined" || !navigator.userAgent) return false;
  const ua = navigator.userAgent.toLowerCase();
  const inAppHints = [
    "fban",
    "fbav",
    "fb_iab",
    "instagram",
    "linkedinapp",
    "twitter",
    "messenger",
    "micromessenger",
    "line",
    "snapchat",
    "pinterest",
    "tiktok",
    "whatsapp",
  ];
  return inAppHints.some((hint) => ua.includes(hint));
};

export default getBrowserInfo; 